import { Float } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { Teacher } from '../teacher.js';

/**
 * Persist the teacher's default choice of whether to always use the Fehlerindex instead of
 * detected/merged grammar rules (a per-exam override, see update-grammar-fi-settings.ts, always wins
 * over this default when set). Only the logged-in teacher's own document is affected.
 */
export const updateGrammarPreferencesMutation = registerMutation({
  operationName: 'updateGrammarPreferencesMutation',
  type: () => Boolean,
  params: [
    { name: 'alwaysUseFi', type: () => Boolean },
    { name: 'languageUseRegradeWordCutoff', type: () => Float },
    { name: 'contentRegradeWordCutoff', type: () => Float },
  ],
  resolve:
    (alwaysUseFi: boolean, languageUseRegradeWordCutoff?: number, contentRegradeWordCutoff?: number) => async () => {
      const sessionData = await CurrentUserInfo.getCurrentUserInfo()({ userID: 1 });
      if (!sessionData?.userID) {
        throw new Error('Nicht autorisiert: Kein User eingeloggt');
      }

      const teacherCollection = await getCollection(Teacher);
      const result = await teacherCollection.updateOne(
        { userID: sessionData.userID },
        {
          $set: {
            grammarPreferences: {
              _class: 'GrammarPreferences',
              alwaysUseFi: Boolean(alwaysUseFi),
              languageUseRegradeWordCutoff: Math.max(0, Math.round(Number(languageUseRegradeWordCutoff ?? 5))),
              contentRegradeWordCutoff: Math.max(0, Math.round(Number(contentRegradeWordCutoff ?? 0))),
            },
          },
        } as any,
      );

      return result.matchedCount > 0;
    },
});
